import { Link } from "react-router-dom";

const Account = () => {

    return(
        <>
            <Link to="/account/change-password">Change Password</Link>
        </>
    )
}

export default Account;